import React, {useState, useEffect, useContext} from 'react';
import { Header } from './';
import { TableUser, Pagination, NavigationBar } from '../components';
import { AddUserModal, UpdateUserModal }  from '../modals';
import { DashboardMenu } from '../components';
import { SiteContext } from '../context';

const Customers = () => {

const { apiUrl } = useContext(SiteContext);

const [users, setUsers] = useState([]);
const [total, setTotal] = useState(null);
const [limit, setLimit] = useState(10);
const [page, setPage] = useState(1);
const [cangoBack, setCangoBack] = useState(true);
const [cangoForward, setCangoForward] = useState(true);
const [updateItem, setUpdateItem] = useState({});
const [msg, setMsg] = useState('');
const [errorMsg, setErrorMsg] = useState('');
const [showModal, setShowModal] = useState(false);
const [showUpdateModal, setShowUpdateModal] = useState(false);
const [userRole, setUserRole] = useState('customer')

useEffect(() => {
  getUsers();
},[page,limit,userRole])

const getUsers = () => {
  fetch(`${apiUrl}/api/users.php?action=fetch&role=${userRole}&page=${page}&limit=${limit}`, {
    method:'get'
  }).then((res) => {
      return res.json();
  }).then((res) => {
      if(res.status === 200) {
          setUsers(res.rows) 
          setTotal(res.count);       
      } else if (res.status === 400) {
          setMsg('No customers found')
          setTimeout(() => {
            setMsg('')
          },3000)
      }
  }).catch((err) => {
      console.log(err)
  })
}

const doPrevious = async () => {
 
  if(parseInt(page) > 1) {
    await setPage(() => parseInt(page - 1));
    setCangoBack(true);
    setCangoForward(true);
  } else {
    setCangoBack(false);
    setCangoForward(true);
  }
}

const doNext = async () => {

  if(parseInt(page * limit) < total) { 
    await setPage(() => parseInt(page + 1));
    setCangoForward(true);
    setCangoBack(true);
  } else {
    setCangoForward(false);
    setCangoBack(true);
  }
}

const handleChange = (event) => {
  let newLimit = event.target.value;
  setLimit(newLimit);
}


const handleSubmit = (values, { setSubmitting, resetForm, setShowModal }) => {

  let formData = new FormData();

  let action = values.id === '' ? 'create' : 'update';

  formData.append('email', values.email);
  formData.append('username', values.username);
  formData.append('name', values.fullname);
  formData.append('phone', values.phone);
  formData.append('password', values.password);
  formData.append('terms', values.agree ? 1 : 0);
  formData.append('address', values.address);
  formData.append('residence', values.residence);
  formData.append('user', values.id);
  formData.append('role', values.role);
  formData.append('fleet', values.fleet);
  formData.append('latitude', values.latitude);
  formData.append('longitude', values.longitude);
  formData.append('isverified', values.isverified ? 1 : 0);
  formData.append('padmin', values.padmin);
  formData.append('isactive', values.isactive ? 1 : 0);
  formData.append('isavailable', values.isavailable ? 1 : 0);
  formData.append('action', action);

  const url = `${apiUrl}/api/users.php`;
  const sendType = 'post';

    return fetch(url, {
      method: sendType,
      body: formData
    })
    .then((res) => res.json())
    .then((response) => {
      if(response.status === 200) {
            resetForm({});
            setShowModal(false);
            setMsg(response.msg);
            getUsers();
            setSubmitting(false);
            setTimeout(() => {
              setMsg('');
            }, 3000);
        } else if(response.status === 400) {
          setErrorMsg(response.msg);
          setTimeout(() => {
            setErrorMsg('');
          }, 5000);
          setSubmitting(false);
        } else {
          alert(
                'Signup failed',
                'Error connection to the server please check your details and try again',
                [{ text: 'Okay' }]
              );
        }
      })
      .catch((error) => {
        console.log('Api call error', error.message);
      });
  };

 
  const handleAdd = () => {
    setShowModal(true);
  }

  const handleUpdate = (user) => {
    setUpdateItem(user);
    setShowUpdateModal(true);
  }

const doDelete = id => {
    fetch(`${apiUrl}/api/users.php?id=${id}&action=delete&role=customer`, {
      method:'get'
    }).then((res) => {
        return res.json()
    }).then((res) => {
      if(res.status === 200) {
        getUsers();
        setMsg(res.msg)
        setTimeout(() => {
          setMsg('')
        },3000)  
      } else if(res.status === 400) {
        setErrorMsg(res.msg)
        setTimeout(() => {
          setErrorMsg('')
        },3000)  
      }
    }).catch((err) => {
        console.log(err)
    })
  }


    return (
        <div>
            <AddUserModal handleSubmit={handleSubmit} showModal={showModal} setShowModal={setShowModal} errorMsg={errorMsg} />
            <UpdateUserModal updateItem={updateItem} handleSubmit={handleSubmit} showModal={showUpdateModal} setShowModal={setShowUpdateModal} errorMsg={errorMsg} />
            <Header />
            <div>
                <div className='row'>
                    <div className='col-md-2 bg-light'>
                        <DashboardMenu />
                    </div>
                    <div className='col-md-10'>
                    <div className='container my-2'>
                      <NavigationBar section={'Users'} goback={false} />

                  <p className='my-2 justify-content-between'><button className={userRole === 'customer' ? 'btn-dark text-white' : 'btn-white text-dark'} onClick={() => setUserRole('customer')}>Customer</button> <button className={userRole === 'orgadmin' ? 'btn-dark text-white' : 'btn-white text-dark'} onClick={() => setUserRole('orgadmin')}>Organisation Admin</button></p>

                <div className='my-2 d-flex justify-content-between'>
                  <div className='align-items-center'>
                  {msg !== '' ? <div className='p-2'><span className='p-2 border border-info text-dark'>{msg}</span></div> : null}
                {errorMsg !== '' ? <div className='p-2'><span className='p-2 border border-info text-dark'>{errorMsg}</span></div> : null}
                  </div>
                  <div>
                    <button className='btn btn-primary' onClick={() => handleAdd()}>New User</button>
                  </div>
                </div>

                <Pagination limit={limit} page={page} total={total} cangoBack={cangoBack} cangoForward={cangoForward} handleChange={handleChange} doNext={doNext} doPrevious={doPrevious} />

                <TableUser users={users} onDelete={doDelete} handleUpdate={handleUpdate} />
            </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Customers;